angular.module('middlewares', [
  'middlewares.isAdmin',
  'middlewares.isLoggedIn'
]);



// WEBPACK FOOTER //
// ./client/src/common/middlewares/index.js